class DetailsModal extends HTMLElement {
  constructor() {
    super()
    this.detailsContainer = this.querySelector("details")
    this.summaryToggle = this.querySelector("summary")

    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close(),
    )
    this.summaryToggle.addEventListener("click", this.onSummaryClick.bind(this))
    // Bind the close control directly. Chip buttons are also type="button"
    // and sit earlier in the markup, so a first-button query misses the X.
    const closeButton = this.querySelector(".modal__close-button")
    if (closeButton)
      closeButton.addEventListener("click", this.close.bind(this))

    this.summaryToggle.setAttribute("role", "button")
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open")
  }

  onSummaryClick(event) {
    event.preventDefault()
    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event)
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close(false)
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)
    event.target.closest("details").setAttribute("open", true)
    this.minimizeChatBubble()
    document.body.addEventListener("click", this.onBodyClickEvent)
    document.body.classList.add("overflow-hidden")

    const focusContainer =
      this.detailsContainer.querySelector('[tabindex="-1"]')
    const searchInput = this.detailsContainer.querySelector(
      'input:not([type="hidden"])',
    )
    // On mobile, focusing the search input auto-opens the keyboard, which
    // covers the chips/results. Keep focus on the modal shell until the user
    // taps the field, so the keyboard only appears on an explicit tap.
    const isMobile = window.matchMedia("(max-width: 749px)").matches
    const elementToFocus =
      this.classList.contains("header__search") && isMobile
        ? focusContainer
        : searchInput
    trapFocus(focusContainer, elementToFocus)
  }

  minimizeChatBubble() {
    if (!this.classList.contains("header__search")) return
    const widget = document.getElementById("shopping-assistant-widget")
    if (!widget || !widget.classList.contains("is-open")) return
    const collapse = widget.querySelector("[data-sa-collapse]")
    if (collapse) collapse.click()
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null)
    this.detailsContainer.removeAttribute("open")
    document.body.removeEventListener("click", this.onBodyClickEvent)
    document.body.classList.remove("overflow-hidden")
  }
}

customElements.define("details-modal", DetailsModal)
